
import AddNewOrg from "../Organization/AddNewOrg"
import RegisterUser from "./RegisterUser"
import defaultPage from "./defaultPage"
import HomePage from "./HomePage"


const publicRoutes = [
    {
        path: '/public/home',
        component: defaultPage,
    },
    {
        path: '/public/home_page',
        component: HomePage,
    },
    {
        path: '/user/create',
        component: RegisterUser,
    },
    {
        path: '/organization/create',
        component: AddNewOrg,
    },

    

]

export default publicRoutes
